<template>
  <transition name="danmu">
    <div class="word-and-expression" v-show="show">
      <div class="content-box">
        <div class="textinput">
          <div class="width1200">
            <div class="lefticon">
              <div
                class="color cursor"
                :class="{ color_choose: chooseType === 'color' }"
                @click="chooseType = 'color'"
              ></div>
              <div
                class="text cursor"
                :class="{ text_choose: chooseType === 'text' }"
                @click="chooseType = 'text'"
              ></div>
              <div
                class="img cursor"
                :class="{ img_choose: chooseType === 'img' }"
                @click="chooseType = 'img'"
              ></div>
            </div>
            <div class="rightInput" v-if="is_typewriting == 1">
              <text-area
                from="danmu"
                :placeholder="placeholderTxt"
                :disabled="textareaDisabled || !show"
                :classDisabled="textareaDisabled"
                @selfFocus="hint = ''"
                @selfBlur="hint = '我想说两句(50字以内)'"
                @enter="sendMessage"
                @selfInput="selfInput"
                ref="textarea"
              />
              <button
                class="cursor"
                @click="sendData()"
                :disabled="sendText.replace(/\s/g, '').length == 0"
                :class="{ disabled: sendText.replace(/\s/g, '').length == 0 }"
              >
                发送
              </button>
              <span>Enter发送 / Ctrl+Enter换行</span>
            </div>
            <div class="arrow">
              <i class="cursor" @click="close"></i>
            </div>
          </div>
        </div>
        <div class="img_box" v-show="chooseType === 'img'">
          <span>表情</span>
          <div class="expression">
            <div
              class="item cursor"
              v-for="(item, index) in imgList"
              :key="index"
              @click="sendData(item)"
            >
              <img
                :src="imgBaseUrl + item.imgUrl"
                alt
                ondragstart="return false;"
              />
              <i class="days_left" v-if="item.day!=-1 && item.isBuy==1 && item.day<=15" :class="{'i_red':item.day<=3}" v-text="item.day==0?'当日失效':`剩余${item.day}天`"></i>
              <p>{{ item.tag }}</p>
            </div>
          </div>
        </div>
        <div class="words_box img_box" v-show="chooseType === 'text'">
          <span>弹幕</span>
          <div class="words">
            <p
              class="cursor"
              v-for="(item, index) in textList"
              :key="index"
              @click="sendData(item)"
            >
              <img :src="imgBaseUrl + item.imageUrl" alt="" ondragstart="return false;">
              {{ item.text }}
            </p>
          </div>
        </div>
        <div v-if="chooseType === 'color'" class="set_color">
          <div class="title">弹幕颜色</div>
          <div class="color_list">
            <div
              class="color_item cursor"
              @click="setColor({ styleId: 0, color: '#fff', tag: '默认' })"
            >
              默认
              <div
                v-if="0 === data.barrageStyle.barrageStyleId"
                class="choosed"
              ></div>
            </div>
            <div
              v-for="(item, index) in data.barrageStyle.barrageStyleList"
              :key="index"
              class="color_item cursor"
              :style="getStyle(item)"
              @click="setColor(item)"
            >
              <i class="days_left" v-if="item.day!=-1 && item.isBuy==1 && item.day<=15" :class="{'i_red':item.day<=3}" v-text="item.day==0?'当日失效':`剩余${item.day}天`"></i>
              <div
                v-if="item.styleId === data.barrageStyle.barrageStyleId"
                class="choosed"
              ></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { mapState, mapActions, mapGetters, mapMutations } from "vuex";
import textarea from "./textarea.vue";
export default {
  name: "HelloWorld",
  data() {
    return {
      hint: "我想说两句(50字以内)",
      sendText: "",
      chooseType: "img",
    };
  },
  components: {
    "text-area": textarea,
  },
  props: {
    showExpression: {
      //控制自定表情话术的显示和隐藏
      default: false,
      type: Boolean,
    },
    data: {
      default: {},
    },
  },
  computed: {
    ...mapState(["is_typewriting", "text_banned_speak", "bzr_text_banned"]),
    ...mapGetters(["isExperientialCourse"]),
    show() {
      if (!this.showExpression && this.chooseType === "color") {
        setTimeout(() => {
          this.chooseType = "img";
        }, 500);
      }
      return this.showExpression;
    },
    placeholderTxt() {
      if (this.hint != "") {
        if (this.text_banned_speak == 1) {
          return "老师关闭了打字功能，开启后再使用吧！";
        } else if (this.bzr_text_banned == 1) {
          return "班主任老师关闭了你的打字功能，要认真听课噢！";
        } else {
          return this.hint;
        }
      }
    },
    textareaDisabled() {
      return (
        (this.text_banned_speak == 1 && this.hint != "") ||
        (this.bzr_text_banned == 1 && this.hint != "")
      );
    },
    imgBaseUrl() {
      return this.data.barrage && this.data.barrage.baseUrl;
    },

    imgList() {
      return this.data.barrage && this.data.barrage.list;
    },

    textList() {
      return this.data && this.data.textList;
    },
  },
  methods: {
    ...mapActions(["setFontColor"]),
    ...mapMutations(["changeDanmuFontColor"]),
    getStyle(res) {
      let obj = {
        background: res.color,
      };
      if (res.colorList && res.colorList.length > 1) {
        obj.background = `linear-gradient(180deg,${res.colorList.join(",")})`;
      }
      return obj;
    },
    // 设置弹幕字体颜色
    async setColor(item) {
      if(this.$parent.imageResources.barrageStyle.barrageStyleId==item.styleId)return;
      this.$parent.imageResources.barrageStyle.barrageStyleId = item.styleId;
      this.changeDanmuFontColor({ color: item.styleId });
      this.close();
      let { res, ok } = await this.setFontColor({
        barrageStyleId: item.styleId,
      });
      if (ok) {
        this.$root.eventHub.$emit("createLog", {
          id: "LMTrackEventSwitchTextStyle",
          data: {
            barrageStyleId: item.styleId,
          },
        });
      }
    },
    //获取自定义表情和话术
    selfInput(val) {
      this.sendText = val;
    },
    sendMessage() {
      if (this.sendText.replace(/\s/g, "").length == 0) return;
      this.sendData();
    },
    sendData(item) {
      let sendMsg = item;
      if (!item) {
        sendMsg = {
          type: 4,
          text: this.sendText,
          unique_id: Date.now(),
        };
      } else if (item.imgId) {
        sendMsg.type = 2;
        sendMsg.img = item.imgUrl;
        sendMsg.id = item.imgId;
      } else {
        sendMsg.id = item.textId;
        sendMsg.type = 1;
        sendMsg.text_img = item.imageUrl;
      }
      //点击表情话术
      this.$emit("clickItem", sendMsg);
      if (!item) {
        this.sendText = "";
        this.$refs.textarea.isScroll = false;
        this.$refs.textarea.text = "";
      }
    },
    close(){
      this.$emit("close");
    }
  },
};
</script>
<style scoped lang="less" rel="stylesheet/less">
.word-and-expression {
  width: 100%;
  position: absolute;
  bottom: 0;
  left: 0;
  z-index: 92;
  .content-box {
    min-width: 1200px;
    background: rgba(0, 0, 0, 0.8);
    position: relative;
    left: 50%;
    height: 100%;
    transform: translateX(-50%);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding-bottom: 30px;
  }
}
.img_box {
  width: 1200px;
  overflow-x: hidden;
  margin-top: 20px;
  display: flex;
  span {
    display: block;
    width: 80px;
    font-size: 20px;
    color: #b9b9b9;
    text-align: left;
    line-height: 100px;
  }
}
.words_box span{
  line-height: 154px;
}
.expression {
  .item {
    position: relative;
    width: 60px;
    /*设计图给的是47px但是文字多的时候会折行，需要给出一个盒子的宽度*/
    height: 80px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-right: 25px;
    margin-top: 13px;
    float: left;
    &:hover {
      background-color: #3b3b3b;
      border-radius: 4px;
    }
    img {
      width: 47px;
      height: 47px;
    }
    p {
      width: 100%;
      height: 20px;
      font-size: 10px;
      margin-top: 6px;
      color: #ffffff;
      word-break: break-all;
    }
  }
}
.days_left{
  position: absolute;
  left: 50%;
  top: 29px;
  transform: translateX(-50%);
  width: 70px;
  height: 22px;
  background: #ffffff;
  opacity: .8;
  border-radius: 12px;
  font-size: 13px;
  line-height: 22px;
  text-align: center;
  font-weight: 600;
  color: #000000;
}
.i_red{
  color: #C81A1A;
  opacity: 1;
  background: rgba(255, 255, 255,.6);
}
.words {
  width: 1200px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
  img{
    position: absolute;
    top: -33px;
    left: 50%;
    transform: translateX(-50%);
    height: 32px;
  }
  p {
    position: relative;
    display: flex;
    align-items: center;
    margin-right: 20px;
    height: 45px;
    line-height: 32px;
    padding: 0 15px;
    font-size: 18px;
    color: #ffffff;
    font-weight: 400;
    margin-top: 55px;
    border-radius: 22px;
    border: 1px solid rgba(215, 221, 236, 0.4);
    white-space: nowrap;
    background: #201e1d;
    &:hover {
      border: 1px solid #ffffff;
    }
  }
}
.textinput {
  height: 60px;
  width: 100%;
  // background: rgba(0, 0, 0, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  button {
    font-family: PingFang_Regular;
    height: 45px;
    width: 80px;
    background: #008ACF;
    color: #fff;
    font-size: 16px;
    border-radius: 23px;
  }
  .disabled {
    background: #454545;
    color: rgba(255, 255, 255, 0.6);
    pointer-events: none;
  }
  span {
    line-height: 45px;
    font-size: 13px;
    color: #b6b6b6;
    float: right;
    width: 210px;
  }
}
.width1200 {
  width: 1200px;
  display: flex;
  justify-content: space-between;
  .lefticon {
    display: flex;
    align-items: center;
    div {
      width: 40px;
      height: 40px;
      margin-right: 25px;
    }
    .color {
      background: url("../../../assets/img/video/color.png") no-repeat;
      background-size: cover;
    }
    .img {
      background: url("../../../assets/img/video/img.png") no-repeat;
      background-size: cover;
    }
    .color_choose {
      background: url("../../../assets/img/video/color_choose.png") no-repeat;
      background-size: cover;
    }
    .img_choose {
      background: url("../../../assets/img/video/img_choose.png") no-repeat;
      background-size: cover;
    }
    .text {
      background: url("../../../assets/img/video/danmu_text.png") no-repeat;
      background-size: cover;
    }
    .text_choose {
      background: url("../../../assets/img/video/danmu_text_choose.png")
        no-repeat;
      background-size: cover;
    }
  }
  .rightInput {
    flex: 1;
  }
  .arrow {
    width: 100px;
    height: 33px;
    i{
      display: block;
      width: 33px;
      height: 33px;
      background: url("../../../assets/img/video/arrow_down.png") no-repeat;
      background-size: 33px;
    }

  }
}
.set_color {
  width: 1200px;
  display: flex;
  align-items: center;
  .days_left{
    top: 50%;
    transform: translate(-50%,-50%);
    opacity: 0.6;
  }
  .title {
    text-align: left;
    font-size: 20px;
    font-weight: 500;
    color: #b9b9b9;
    margin-right: 27px;
  }
  .color_list {
    margin-top: 25px;
    padding-bottom: 20px;
    display: flex;
    .color_item {
      position: relative;
      background: #fff;
      color: #0089ce;
      font-size: 17px;
      width: 90px;
      height: 47px;
      border-radius: 6px;
      line-height: 47px;
      margin-right: 30px;
      box-sizing: border-box;
      .choosed {
        width: 92px;
        height: 49px;
        top: -1px;
        left: -1px;
        position: absolute;
        background: url("../../../assets/img/video/color_choosed.png") no-repeat;
        background-size: cover;
      }
    }
  }
}
.danmu-enter-active {
  animation: slideTop 0.6s cubic-bezier(0.645, 0.045, 0.355, 1);
}

.danmu-leave-active {
  animation: slideTop 0.6s reverse cubic-bezier(0.645, 0.045, 0.355, 1);
}
</style>



// WEBPACK FOOTER //
// src/components/bussiness/video/wordsAndExpression.vue